import React, { createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RouteContents from "../../constants/routesContent.json";
import { useState } from "react";
import { getVisitorsList, getVisitorsDetails } from "../../api/Api";

export const VisitorsMappingContext = createContext({});

export const VisitorsMappingContextProvider = ({ children }) => {
  const [visitorsData, setVisitorsData] = useState([]);
  const [visitorsDataOne, setVisitorsDataOne] = useState([]);
  const [visitorsDataTwo, setVisitorsDataTwo] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [statusCode, setStatusCode] = useState(0);
  const [statusData, setStatusData] = useState(1);
  const [categoryRequired, setCategoryRequired] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState("Select Filter");

  // zone table pagination
  const [allZonePageNumber, setAllZonePageNumber] = useState(1);
  const [zoneOnePageNumber, setZoneOnePageNumber] = useState(1);
  const [zoneTwoPageNumber, setZoneTwoPageNumber] = useState(1);

  // zone table pagination - pagecount
  const [allZonePageCount, setAllZonePageCount] = useState(1);
  const [zoneOnePageCount, setZoneOnePageCount] = useState(1);
  const [zoneTwoPageCount, setZoneTwoPageCount] = useState(1);
  const [spinnerStatus ,setSpinnerStatus] = useState(false)
  const handleAlertSubmit = () => {
    setShowAlert(false);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContents.LOGIN);
  };

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  const callVistorsListApi = async (pageNumber) => {
    const data = {
      page: pageNumber,
      zone: "",
    };
    setSpinnerStatus(true)
    try {
      const getData = await getVisitorsList(data);
      if (getData?.data?.status === 200 || getData?.data?.status === 201) {
        setSpinnerStatus(false)
        setVisitorsData(getData.data?.data?.docs);
        setAllZonePageCount(getData.data?.data?.numberOfPages);
      }
    } catch (error) {
      setSpinnerStatus(false)
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const callVistorsListApiOne = async (pageNumber) => {
    const data = {
      page: pageNumber,
      zone: 1,
    };
    setSpinnerStatus(true)
    try {
      const getData = await getVisitorsList(data);
      if (getData?.data?.status === 200 || getData?.data?.status === 201) {
        setSpinnerStatus(false)
        setVisitorsDataOne(getData.data?.data?.docs);
        setZoneOnePageCount(getData.data?.data?.numberOfPages);
      }
    } catch (error) {
      setSpinnerStatus(false)
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const callVistorsListApiTwo = async (pageNumber) => {
    const data = {
      page: pageNumber,
      zone: 2,
    };
    setSpinnerStatus(true)
    try {
      const getData = await getVisitorsList(data);
      if (getData?.data?.status === 200 || getData?.data?.status === 201) {
        setSpinnerStatus(false)
        setVisitorsDataTwo(getData.data?.data?.docs);
        setZoneTwoPageCount(getData.data?.data?.numberOfPages);
      }
    } catch (error) {
      setSpinnerStatus(false)
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const visitorsDetails = (visitorId) => {
    callGetVisitorDetail(visitorId);
  };
  const editVisitorDetails = (visitorId) => {
    callGetVisitorDetail(visitorId, true);
  };

  const callGetVisitorDetail = async (visitorId, isEdit) => {
    try {
      const getData = await getVisitorsDetails(visitorId);

      if (getData.data.status === 200) {
        const visitorInfo = getData.data.data;
        {
          isEdit
            ? navigate(RouteContents.GUEST_REGISTER, {
                state: {
                  isEdit: true,
                  visitorInfo: visitorInfo,
                  visitorId: visitorId,
                },
              })
            : navigate(RouteContents.VISITORS_DETAILS, {
                state: { visitorInfo: visitorInfo, visitorId: visitorId },
              });
        }
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 403 ||
        error?.response?.data?.status === 400
      ) {
        const errorMessage = error?.response?.data?.message;
        setShowAlert(true);
        setAlertMessage(errorMessage);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  const guestRegister = () => {
    navigate(RouteContents.GUEST_REGISTER, {
      state: { isEdit: false },
    });
  };

  useEffect(() => {
    callVistorsListApi(allZonePageNumber);
  }, []);

  const onPageChangeAllZone = (e) => {
    setAllZonePageNumber(e);
    callVistorsListApi(e);
  };
  const onPageChangeZoneTwo = (e) => {
    setZoneOnePageNumber(e);
    callVistorsListApiOne(e);
  };
  const onPageChangeZoneOne = (e) => {
    setZoneTwoPageNumber(e);
    callVistorsListApiTwo(e);
  };

  const onSelectTab = (e) => {
    setStatusData(e);
    if (e === "0") {
      callVistorsListApi(1);
      setAllZonePageNumber(1);
    } else if (e === "1") {
      callVistorsListApiOne(1);
      setZoneOnePageNumber(1);
    } else if (e === "2") {
      callVistorsListApiTwo(1);
      setZoneTwoPageNumber(1);
    }
  };

  const providerValue = {
    guestRegister,
    visitorsDetails,
    goBack,
    editVisitorDetails,
    visitorsData,
    showAlert,
    setShowAlert,
    visitorsDataOne,
    visitorsDataTwo,
    alertMessage,
    statusCode,
    setAlertMessage,
    setStatusData,
    filterCriteria,
    setFilterCriteria,
    handleAlertSubmit,
    pageCount,
    categoryRequired,
    logout,
    // zone table pagination
    zoneOnePageNumber,
    allZonePageNumber,
    zoneTwoPageNumber,

    // Zone table page count
    allZonePageCount,
    zoneOnePageCount,
    zoneTwoPageCount,

    // set state
    setAllZonePageNumber,
    setZoneOnePageNumber,
    setZoneTwoPageNumber,

    onSelectTab, // function on select tab
    // on page change
    onPageChangeAllZone,
    onPageChangeZoneTwo,
    onPageChangeZoneOne,
    spinnerStatus ,setSpinnerStatus
  };
  return (
    <VisitorsMappingContext.Provider value={providerValue}>
      {children}
    </VisitorsMappingContext.Provider>
  );
};
